import { effect, inject, Injectable } from '@angular/core';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class KeycloakRefreshService {
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
  private readonly keycloak = inject(Keycloak);
  constructor() {
    this.subscribeToKeycloakEvents();
  }

  private subscribeToKeycloakEvents() {
    effect(() => {
      const keycloakEvent = this.keycloakSignal();

      if (keycloakEvent.type === KeycloakEventType.TokenExpired) {
        this.keycloak.updateToken(20).then(refreshed => {
          if (!refreshed) {
            this.keycloak.login();
          }
        });
      }
    });
  }
}
